export default __webpack_public_path__ + "static/media/img1.815eb17a.jpg";